function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ToggleSwitch } from 'flowbite-react';
import { TbAdjustmentsHorizontal } from "react-icons/tb";
import { useTheme } from 'next-themes';
import { Config } from "../../app.config";
import { useSearchContext } from "../utils/Context";
import { compress, gaEvent } from "../utils/Utils";
var Options = function Options() {
  var _useSearchContext = useSearchContext(),
    options = _useSearchContext.options,
    setOptions = _useSearchContext.setOptions;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mounted = _useState2[0],
    setMounted = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    show = _useState4[0],
    setShow = _useState4[1];
  var _useTheme = useTheme(),
    theme = _useTheme.theme,
    setTheme = _useTheme.setTheme;
  useEffect(function () {
    return setMounted(true);
  }, []);
  if (!mounted) return null;
  var handleClose = function handleClose() {
    localStorage.setItem(Config.id + "-options", compress(options));
    setShow(false);
  };
  var toggleShow = function toggleShow() {
    return setShow(function (s) {
      return !s;
    });
  };
  var handleChange = function handleChange(name, checked) {
    setOptions(function (oldOptions) {
      return _objectSpread(_objectSpread({}, oldOptions), {}, _defineProperty({}, name, checked));
    });
    if (name === "darkMode") {
      if (checked) {
        setTheme('dark');
      } else {
        setTheme('light');
      }
    }
    gaEvent("Options", {
      category: "Options",
      label: "name",
      value: checked ? "Yes" : "No",
      nonInteraction: true
    });
  };
  var optionAvailable = [{
    id: 'dark-mode',
    label: "Dark Mode",
    name: "darkMode",
    checked: options.darkMode
  }, {
    id: 'old-reddit',
    label: "Old Reddit",
    name: "oldReddit",
    checked: options.oldReddit
  }, {
    id: 'show-date',
    label: "Show Date",
    name: "showDate",
    checked: options.showDate
  }, {
    id: 'show-suggestions',
    label: "Show Suggestions",
    name: "showSuggestions",
    checked: options.showSuggestions
  }];
  var optionsList = optionAvailable.map(function (option, index) {
    return /*#__PURE__*/React.createElement(ToggleSwitch, {
      color: "blue",
      key: index,
      id: option.id,
      name: option.name,
      label: option.label,
      checked: option.checked,
      onChange: function onChange(checked) {
        return handleChange(option.name, checked);
      }
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    color: "blue",
    size: "sm",
    title: "".concat(Config.name, " Options"),
    "aria-label": "".concat(Config.name, " Options"),
    "aria-haspopup": true,
    onClick: toggleShow
  }, /*#__PURE__*/React.createElement(TbAdjustmentsHorizontal, {
    className: "h-5 w-5"
  })), /*#__PURE__*/React.createElement(Modal, {
    show: show,
    "aria-labelledby": "options-modal",
    onClose: handleClose,
    size: "sm"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    id: "options-modal"
  }, Config.name, " Options"), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("form", {
    className: ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, optionsList))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    color: "blue",
    "aria-label": "Close",
    onClick: handleClose,
    fullSized: true
  }, "OK"))));
};
export default Options;